export default "__VITE_ASSET__BoDsNNR6__"